/* CATZYFIED Mobile ATC V1 — Erweiterung des nativen Impulse-Buttons.
   Keine eigenen Cart-API-Aufrufe, keine Preis-/Variant-Manipulation. */
(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 768px)');
  let teardown = null;

  function setup() {
    if (teardown) teardown();
    teardown = null;
    if (!document.body || !document.body.classList.contains('template-product')) return;

    const section = document.querySelector(
      '.main-content .product-section[data-section-type="product"][data-modal="false"]'
    );
    if (!section) return;
    const nativeButton = section.querySelector('.product-single__form button[data-add-to-cart]');
    if (!nativeButton) return; // Bundle-Seiten ohne nativen Kaufbutton werden ausgelassen.

    const nativeLabel = nativeButton.querySelector('[data-add-to-cart-text]');
    const nativePrice = section.querySelector('.product-block--price [data-product-price]');
    const bar = document.createElement('div');
    bar.className = 'catzy-mobile-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Schnellkauf');

    const inner = document.createElement('div');
    inner.className = 'catzy-mobile-atc__inner';
    const details = document.createElement('div');
    details.className = 'catzy-mobile-atc__details';
    const name = document.createElement('div');
    name.className = 'catzy-mobile-atc__name';
    name.textContent = section.getAttribute('data-product-title') || '';
    const price = document.createElement('div');
    price.className = 'catzy-mobile-atc__price';
    details.append(name, price);
    const button = document.createElement('button');
    button.className = 'catzy-mobile-atc__button';
    button.type = 'button'; // niemals ein weiteres Produktformular submitten
    inner.append(details, button);
    bar.appendChild(inner);
    document.body.appendChild(bar);

    const observers = [];
    let frame = 0;
    const sync = () => {
      if (!bar.isConnected) return;
      const label = (nativeLabel?.textContent || '').trim();
      button.textContent = label || 'In den Warenkorb';
      button.disabled = nativeButton.disabled;
      if (nativePrice) {
        const value = (nativePrice.textContent || '').trim();
        price.textContent = value;
        price.hidden = !value;
      } else {
        price.hidden = true;
      }
    };

    const visibility = () => {
      frame = 0;
      const rect = nativeButton.getBoundingClientRect();
      const overlayOpen = document.body.classList.contains('js-drawer-open') ||
        document.body.classList.contains('js-drawer-open--search') ||
        document.body.classList.contains('modal-open') ||
        !!document.querySelector('.pswp--open');
      const show = mobile.matches && rect.bottom < 0 && !overlayOpen;
      document.body.classList.toggle('catzy-mobile-atc-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      button.tabIndex = show ? 0 : -1;
    };
    const scheduleVisibility = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(visibility);
    };
    const onClick = () => {
      if (nativeButton.disabled || !nativeButton.isConnected) return;
      // Native Impulse-Handler behält Variantenauswahl, Abos,
      // Formular-Validierung und Cart Drawer vollständig unter Kontrolle.
      nativeButton.click();
      scheduleVisibility();
    };

    button.addEventListener('click', onClick);
    window.addEventListener('scroll', scheduleVisibility, {passive: true});
    window.addEventListener('resize', scheduleVisibility, {passive: true});
    document.addEventListener('visibilitychange', scheduleVisibility);

    const buttonObserver = new MutationObserver(sync);
    buttonObserver.observe(nativeButton, {attributes: true, attributeFilter: ['disabled']});
    observers.push(buttonObserver);
    if (nativeLabel) {
      const labelObserver = new MutationObserver(sync);
      labelObserver.observe(nativeLabel, {childList: true, characterData: true, subtree: true});
      observers.push(labelObserver);
    }
    if (nativePrice) {
      const priceObserver = new MutationObserver(sync);
      priceObserver.observe(nativePrice, {childList: true, characterData: true, subtree: true});
      observers.push(priceObserver);
    }
    const overlayObserver = new MutationObserver(scheduleVisibility);
    overlayObserver.observe(document.body, {attributes: true, attributeFilter: ['class']});
    observers.push(overlayObserver);
    sync();
    visibility();

    teardown = () => {
      window.removeEventListener('scroll', scheduleVisibility);
      window.removeEventListener('resize', scheduleVisibility);
      document.removeEventListener('visibilitychange', scheduleVisibility);
      button.removeEventListener('click', onClick);
      observers.forEach(observer => observer.disconnect());
      if (frame) window.cancelAnimationFrame(frame);
      bar.remove();
      document.body.classList.remove('catzy-mobile-atc-visible');
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, {once: true});
  } else {
    setup();
  }
  // Der Shopify Theme-Editor kann die Produkt-Section ohne Reload ersetzen.
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector?.('.product-section[data-section-type="product"]')) setup();
  });
})();
